import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.users-field.icon-label',
		defaultMessage: 'Users field icon',
		description:
			'Accessible label for the icon representing the users field in a Jira work item action card.',
	},
});

export function UsersFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<PeopleGroupIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
